export const AUTH_TOKEN = 'auth_token';
export const USER_PROJECT = 'project';
export const USER_ID = 'id';
export const USER_NAME = 'name';
export const USER_EMAIL = 'email';
export const USER_ROLE = 'role';
export const USER_OTP_ENABLED = 'otp_enabled';
export const YK_OFFERS_CHECKER_PROCESS_ID = 'yk_offers_process_id';
export const YK_OFFERS_CHECKER_CHECKER_SHOW = 'yk_offers_checker_show';
